import { render, staticRenderFns } from "./OrderCustomerInfo.vue?vue&type=template&id=26a9f03e&scoped=true&"
import script from "./OrderCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderCustomerInfo.vue?vue&type=style&index=0&id=26a9f03e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a9f03e",
  null
  
)

export default component.exports